import { InvitationDisplayMode } from '../enums/Enum';
import Animator from './Animator';

export default class DropDownAnimator extends Animator {
    constructor(configurations, dom) {
        super(configurations, dom)
    }

    animate(options) {
        const me = this;
        const position = options.isPageRefreshed
            ? me.configuration.secondaryPosition
            : me.configuration.position;
        if (options.isPageRefreshed && me.configuration.rememberShownState) {
            me.slide(options, me.configuration, position);
        } else if (me.configuration.invitationDisplayMode === InvitationDisplayMode.Appear) {
            const pureElement = me.getPureElement(options.element);
            const ele = me.getElement(options.element, pureElement);
            ele.style.display = 'block';
        } else if (me.configuration.invitationDisplayMode === InvitationDisplayMode.Slide) {
            me.slide(options, me.configuration, position);
        } else if (me.configuration.invitationDisplayMode === InvitationDisplayMode.SlideFromLeft) {
            me.slideFromLeft(options, me.configuration, position);
        } else if (
            me.configuration.invitationDisplayMode === InvitationDisplayMode.SlideFromRight
        ) {
            me.slideFromRight(options, me.configuration, position);
        } else {
            me.slideDrop(options, me.configuration, position);
        }
    }
}